var DevelopMeFx =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 18);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CIRCLE_RESOLUTION = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _allocate = __webpack_require__(1);

var _allocate2 = _interopRequireDefault(_allocate);

var _vector = __webpack_require__(14);

var _vector2 = _interopRequireDefault(_vector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** Amount of force with which a point is either attracted or repulsed by the invisible center */
var POINT_CENTER_FORCE = 0.001;

/** Amount of force with which the points repulse each other */
var POINT_FORCE = 0.0005;

var POINT_CROSS_FORCE = 0.0004;

var DRAG_FORCE = 0.01;

/** Amount of force with which invisible center is attracted to the sine-based center target */
var CENTER_TARGET_ATTRACTION_FORCE = 0.005;

/** controls the loss of impulse for our points. lower friction leads to longer, more springy movement */
var FRICTION = 0.03;

/**
 * Maximum distance for which a point will be considered as being close to the mouse.
 */
var MOUSE_DISTANCE = 64;

/**
 * Number physically simulated circle points forming a regular inscribed polygon. Must be a multiple of 3.
 *
 * Each has a repulsive spring connection to its neighbor points and both a repulsive and attractive connection
 * to a invisible center point
 *
 * Also we are connecting the points across the circle in a triangle formation where every dot is connected to the
 * dots a third of the circle to the left and to the right of it. (hence the multiple of 3 requirement)
 *
 */
var CIRCLE_RESOLUTION = exports.CIRCLE_RESOLUTION = 9;

/** How much mass does the invisible center point have? ( circle points have a mass of 1) */
var CENTER_MASS = 1;

/** how large is the sine-movement of the ideal center target points compared to the circle size? */
var MOVEMENT_FACTOR = 0.07;

/** distance of the control points in relation to the radius size */
var CONTROL_SCALE = 0.25;

/** speed multiplier for speed table below */
var SPEED_FACTOR = 0.004;

/** Speeds picked at random for the sine-based center target position */
var SPEEDS = [SPEED_FACTOR, 3 * SPEED_FACTOR, 5 * SPEED_FACTOR, 7 * SPEED_FACTOR, 11 * SPEED_FACTOR, 13 * SPEED_FACTOR, 17 * SPEED_FACTOR];

////////////////////////////////////////////////// INTERNAL CONSTANTS //////////////////////////////////////////////////

var TAU = Math.PI * 2;

// Array elements per simulation point: x,y, dx,dy, mass
var ELEMENTS = 5;

/** <ELEMENTS> float values per circle point */
var CIRCLE_POINT_LEN = CIRCLE_RESOLUTION * ELEMENTS;
/** Array offset for the center target point which is the point the center follows */
var CENTER_TARGET_OFFSET = CIRCLE_POINT_LEN;
/** current mouse pos offset */
var MOUSE_POS_OFFSET = CIRCLE_POINT_LEN + ELEMENTS;

var AVERAGE_POS_OFFSET = CIRCLE_POINT_LEN + 2 * ELEMENTS;

// .. plus the invisible center point plus center target plus mouse pos
var DATA_LEN = CIRCLE_POINT_LEN + 3 * ELEMENTS;

var sqrt = Math.sqrt;

function randomSpeed() {
    return SPEEDS[Math.random() * SPEEDS.length | 0];
}

/**
 * Returns the edge size of a n-sided regular inscribed polygon inside a circle of the given radius.
 *
 * @param n             number of sides
 * @param radius        radius
 * @returns {number}
 */
function getEdgeLength(n, radius) {
    return 2 * radius * Math.sin(TAU / n / 2);
}

var vControl1 = new _vector2.default(0, 0);
var vControl2 = new _vector2.default(0, 0);

var Circle = function () {
    function Circle(ctx, x, y, size, config) {
        _classCallCheck(this, Circle);

        this.ctx = ctx;
        this.x = x;
        this.y = y;
        this.size = size;
        this.color = config.color;
        this.lineWidth = config.lineWidth;
        this.minDistanceIndex = -1;

        this.isDragged = false;
        this.dragOffsetX = 0;
        this.dragOffsetY = 0;

        this.ax0 = 0; //Math.random() * TAU;
        this.ay0 = 0; //Math.random() * TAU;
        this.ax1 = 0; //Math.random() * TAU;
        this.ay1 = 0; //Math.random() * TAU;

        this.dx0 = randomSpeed();
        this.dy0 = randomSpeed();
        this.dx1 = randomSpeed();
        this.dy1 = randomSpeed();

        this.controlPointDistance = CONTROL_SCALE * size / 2;

        var angleStep = TAU / CIRCLE_RESOLUTION;

        var data = (0, _allocate2.default)(DATA_LEN);
        this.data = data;
        var radius = size * 0.5;

        for (var i = 0, a = 0; i < CIRCLE_POINT_LEN; i += ELEMENTS, a += angleStep) {
            // init all circle points with position in <size> distance and zero velocity
            data[i] = this.x + Math.cos(a) * radius;
            data[i + 1] = this.y + Math.sin(a) * radius;
            data[i + 2] = 0;
            data[i + 3] = 0;
            data[i + 4] = 1;
        }
    }

    _createClass(Circle, [{
        key: "updateCenter",
        value: function updateCenter() {
            var offset = this.size * MOVEMENT_FACTOR;
            var smallOffset = offset * 0.61803398875;

            this.data[CENTER_TARGET_OFFSET] = this.x + Math.cos(this.ax0) * offset + Math.cos(this.ax1) * smallOffset;
            this.data[CENTER_TARGET_OFFSET + 1] = this.y + Math.sin(this.ay0) * offset + Math.sin(this.ay1) * smallOffset;

            this.ax0 += this.dx0;
            this.ay0 += this.dy0;
            this.ax1 -= this.dx1;
            this.ay1 -= this.dy1;
        }
    }, {
        key: "render",
        value: function render(stats) {
            var ctx = this.ctx,
                data = this.data,
                minDistanceIndex = this.minDistanceIndex;


            ctx.lineWidth = this.lineWidth;
            ctx.strokeStyle = this.color;

            var x0 = data[0];
            var y0 = data[1];

            ctx.save();
            ctx.beginPath();
            ctx.globalAlpha = 0.6;
            ctx.moveTo(x0, y0);

            for (var i = ELEMENTS; i < CIRCLE_POINT_LEN; i += ELEMENTS) {
                var x1 = data[i];
                var y1 = data[i + 1];

                this.drawBezier(x0, y0, x1, y1, stats);
                x0 = x1;
                y0 = y1;
            }

            this.drawBezier(x0, y0, data[0], data[1], stats);
            ctx.stroke();
            ctx.restore();

            if (minDistanceIndex > 0) {
                var x = data[minDistanceIndex];
                var y = data[minDistanceIndex + 1];

                ctx.strokeStyle = "rgba(255,255,255,0.66)";
                ctx.beginPath();
                ctx.arc(x, y, 5, 0, TAU, false);
                ctx.stroke();
            }

            if (false) {
                if (stats.cpLine) {
                    var _data = this.data;


                    var centerTargetX = _data[CENTER_TARGET_OFFSET];
                    var centerTargetY = _data[CENTER_TARGET_OFFSET + 1];
                    var averageX = _data[AVERAGE_POS_OFFSET];
                    var averageY = _data[AVERAGE_POS_OFFSET + 1];

                    ctx.fillStyle = "#f00";
                    ctx.fillRect(centerTargetX, centerTargetY, 2, 2);

                    ctx.fillStyle = "#0f0";
                    ctx.fillRect(averageX, averageY, 2, 2);
                }
            }
        }
    }, {
        key: "drawBezier",
        value: function drawBezier(x1, y1, x2, y2, stats) {
            var centerX = this.data[AVERAGE_POS_OFFSET];
            var centerY = this.data[AVERAGE_POS_OFFSET + 1];

            vControl1.x = centerX - x1;
            vControl1.y = centerY - y1;

            vControl2.x = centerX - x2;
            vControl2.y = centerY - y2;

            vControl1.rotateClockwise().norm(this.controlPointDistance).add(x1, y1);
            vControl2.rotateCounterClockwise().norm(this.controlPointDistance).add(x2, y2);

            var ctx = this.ctx;


            if (false) {
                if (stats.cpLine) {
                    // if we have a buffer we collect the debug lines between circle points and control points
                    var pos = stats.cpPos;
                    stats.cpLine[pos++] = x1;
                    stats.cpLine[pos++] = y1;
                    stats.cpLine[pos++] = vControl1.x;
                    stats.cpLine[pos++] = vControl1.y;
                    stats.cpLine[pos++] = vControl2.x;
                    stats.cpLine[pos++] = vControl2.y;
                    stats.cpLine[pos++] = x2;
                    stats.cpLine[pos++] = y2;
                    stats.cpPos = pos;
                }
            }

            // .. and extend the current AABB by the control points
            stats.aabb.extend(vControl1.x, vControl1.y);
            stats.aabb.extend(vControl2.x, vControl2.y);

            ctx.bezierCurveTo(vControl1.x, vControl1.y, vControl2.x, vControl2.y, x2, y2);
        }
    }, {
        key: "update",
        value: function update(stats) {
            this.updateCenter();

            var data = this.data,
                size = this.size,
                minDistanceIndex = this.minDistanceIndex;
            var aabb = stats.aabb;


            var centerTargetX = data[CENTER_TARGET_OFFSET];
            var centerTargetY = data[CENTER_TARGET_OFFSET + 1];

            //aabb.extend(centerTargetX,centerTargetY);


            // springs at the edges of the regular polygon between circle points.

            var avgX = data[0];
            var avgY = data[1];

            var radius = size / 2;
            var maxPointDistance = getEdgeLength(CIRCLE_POINT_LEN, radius);
            for (var i = ELEMENTS; i < CIRCLE_POINT_LEN; i += ELEMENTS) {
                this.attract(i, i - ELEMENTS, maxPointDistance, POINT_FORCE);
                this.repulse(i, i - ELEMENTS, maxPointDistance, POINT_FORCE);

                avgX += data[i];
                avgY += data[i + 1];
            }
            this.attract(0, CIRCLE_POINT_LEN - ELEMENTS, maxPointDistance, POINT_FORCE);
            this.repulse(0, CIRCLE_POINT_LEN - ELEMENTS, maxPointDistance, POINT_FORCE);

            avgX /= CIRCLE_RESOLUTION;
            avgY /= CIRCLE_RESOLUTION;

            data[AVERAGE_POS_OFFSET] = avgX;
            data[AVERAGE_POS_OFFSET + 1] = avgY;

            var thirdLength = CIRCLE_POINT_LEN / 3;
            var thirdDist = getEdgeLength(3, radius);

            for (var _i = thirdLength; _i < CIRCLE_POINT_LEN - thirdLength; _i += ELEMENTS) {
                // current point -> third left
                this.attract(_i, _i - thirdLength, thirdDist, POINT_CROSS_FORCE);
                this.repulse(_i, _i - thirdLength, thirdDist, POINT_CROSS_FORCE);
                // current point -> third right
                this.attract(_i, _i + thirdLength, thirdDist, POINT_CROSS_FORCE);
                this.repulse(_i, _i + thirdLength, thirdDist, POINT_CROSS_FORCE);
                // between the other two points
                this.attract(_i - thirdLength, _i + thirdLength, thirdDist, POINT_CROSS_FORCE);
                this.repulse(_i - thirdLength, _i + thirdLength, thirdDist, POINT_CROSS_FORCE);
            }

            for (var _i2 = 0; _i2 < CIRCLE_POINT_LEN; _i2 += ELEMENTS) {
                this.attract(_i2, AVERAGE_POS_OFFSET, radius, POINT_CENTER_FORCE);
                this.repulse(_i2, AVERAGE_POS_OFFSET, radius, POINT_CENTER_FORCE);

                this.attract(_i2, CENTER_TARGET_OFFSET, radius, CENTER_TARGET_ATTRACTION_FORCE);
            }

            if (this.isDragged && minDistanceIndex > 0) {
                this.attract(minDistanceIndex, MOUSE_POS_OFFSET, 0, DRAG_FORCE);
            }

            // apply deltas for all circle points
            for (var _i3 = 0; _i3 < CIRCLE_POINT_LEN; _i3 += ELEMENTS) {
                var x = data[_i3];
                var y = data[_i3 + 1];

                x += data[_i3 + 2];
                y += data[_i3 + 3];

                data[_i3] = x;
                data[_i3 + 1] = y;
                data[_i3 + 2] *= 1 - FRICTION;
                data[_i3 + 3] *= 1 - FRICTION;

                aabb.extend(x, y);
            }
        }
    }, {
        key: "repulse",
        value: function repulse(off0, off1, distance, force) {
            var data = this.data;


            var x0 = data[off0];
            var y0 = data[off0 + 1];

            var x = data[off1] - x0;
            var y = data[off1 + 1] - y0;

            var d = sqrt(x * x + y * y);

            var mass0 = data[off0 + 4];
            var mass1 = data[off1 + 4];

            if (d < distance && d > 0) {
                // scale force proportional to the current distance
                var f = force * sqrt(d);

                // scale target vector to force
                var sx = x * f / d;
                var sy = y * f / d;

                data[off0 + 2] -= sx / mass0;
                data[off0 + 3] -= sy / mass0;

                data[off1 + 2] += sx / mass1;
                data[off1 + 3] += sy / mass1;
            }
        }
    }, {
        key: "attract",
        value: function attract(off0, off1, distance, force) {
            var data = this.data;


            var x0 = data[off0];
            var y0 = data[off0 + 1];
            var x1 = data[off1];
            var y1 = data[off1 + 1];

            var mass0 = data[off0 + 4];
            var mass1 = data[off1 + 4];

            var x = x1 - x0;
            var y = y1 - y0;

            var d = sqrt(x * x + y * y);
            if (d > distance) {
                var f = force * sqrt(d - distance);

                // scale target vector to distance beyond limit
                var sx = x * f / d;
                var sy = y * f / d;

                data[off0 + 2] += sx / mass0;
                data[off0 + 3] += sy / mass0;

                data[off1 + 2] -= sx / mass1;
                data[off1 + 3] -= sy / mass1;
            }
        }
    }, {
        key: "updateMouse",
        value: function updateMouse(x, y) {
            var data = this.data,
                isDragged = this.isDragged;


            data[MOUSE_POS_OFFSET] = x;
            data[MOUSE_POS_OFFSET + 1] = y;

            if (!isDragged) {

                var minDistance = Infinity;
                var minDistanceIndex = -1;

                for (var i = 0; i < CIRCLE_POINT_LEN; i += ELEMENTS) {
                    var dx = x - data[i];
                    var dy = y - data[i + 1];

                    if (Math.abs(dx) < MOUSE_DISTANCE && Math.abs(dy) < MOUSE_DISTANCE) {
                        var d = sqrt(dx * dx + dy * dy);
                        if (d < minDistance) {
                            minDistance = d;
                            minDistanceIndex = i;
                        }
                    }
                }

                this.minDistanceIndex = minDistanceIndex;
            }
        }
    }]);

    return Circle;
}();

exports.default = Circle;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var supportsTypedArrays = typeof Float32Array === "function";

var allocate = void 0;

if (supportsTypedArrays) {
    allocate = function allocate(n) {
        return new Float32Array(n);
    };
} else {
    allocate = function allocate(n) {
        return new Array(n);
    };
}

exports.default = allocate;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * A fast javascript implementation of simplex noise by Jonas Wagner
 *
 * Based on a speed-improved simplex noise algorithm for 2D, 3D and 4D in Java.
 * Which is based on example code by Stefan Gustavson (stegu@itn.liu.se).
 * With Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
 * Better rank ordering method by Stefan Gustavson in 2012.
 *
 *
 * Copyright (C) 2016 Jonas Wagner
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */

// Code take from NPM module "simplex-noise", but only the noise2D code

var F2 = 0.5 * (Math.sqrt(3.0) - 1.0);
var G2 = (3.0 - Math.sqrt(3.0)) / 6.0;

var SimplexNoise = function () {
    function SimplexNoise(random) {
        _classCallCheck(this, SimplexNoise);

        if (!random) {
            random = Math.random;
        }
        this.p = buildPermutationTable(random);
        this.perm = new Uint8Array(512);
        this.permMod12 = new Uint8Array(512);
        for (var i = 0; i < 512; i++) {
            this.perm[i] = this.p[i & 255];
            this.permMod12[i] = this.perm[i] % 12;
        }
        this.grad3 = new Float32Array([1, 1, 0, -1, 1, 0, 1, -1, 0, -1, -1, 0, 1, 0, 1, -1, 0, 1, 1, 0, -1, -1, 0, -1, 0, 1, 1, 0, -1, 1, 0, 1, -1, 0, -1, -1]);
        this.grad4 = new Float32Array([0, 1, 1, 1, 0, 1, 1, -1, 0, 1, -1, 1, 0, 1, -1, -1, 0, -1, 1, 1, 0, -1, 1, -1, 0, -1, -1, 1, 0, -1, -1, -1, 1, 0, 1, 1, 1, 0, 1, -1, 1, 0, -1, 1, 1, 0, -1, -1, -1, 0, 1, 1, -1, 0, 1, -1, -1, 0, -1, 1, -1, 0, -1, -1, 1, 1, 0, 1, 1, 1, 0, -1, 1, -1, 0, 1, 1, -1, 0, -1, -1, 1, 0, 1, -1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, -1, 1, 1, 1, 0, 1, 1, -1, 0, 1, -1, 1, 0, 1, -1, -1, 0, -1, 1, 1, 0, -1, 1, -1, 0, -1, -1, 1, 0, -1, -1, -1, 0]);
    }

    _createClass(SimplexNoise, [{
        key: "noise2D",
        value: function noise2D(xin, yin) {
            var permMod12 = this.permMod12;
            var perm = this.perm;
            var grad3 = this.grad3;
            var n0 = 0; // Noise contributions from the three corners
            var n1 = 0;
            var n2 = 0;
            // Skew the input space to determine which simplex cell we're in
            var s = (xin + yin) * F2; // Hairy factor for 2D
            var i = Math.floor(xin + s);
            var j = Math.floor(yin + s);
            var t = (i + j) * G2;
            var X0 = i - t; // Unskew the cell origin back to (x,y) space
            var Y0 = j - t;
            var x0 = xin - X0; // The x,y distances from the cell origin
            var y0 = yin - Y0;
            // For the 2D case, the simplex shape is an equilateral triangle.
            // Determine which simplex we are in.
            var i1 = void 0,
                j1 = void 0; // Offsets for second (middle) corner of simplex in (i,j) coords
            if (x0 > y0) {
                i1 = 1;
                j1 = 0;
            } // lower triangle, XY order: (0,0)->(1,0)->(1,1)
            else {
                    i1 = 0;
                    j1 = 1;
                } // upper triangle, YX order: (0,0)->(0,1)->(1,1)
            // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
            // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
            // c = (3-sqrt(3))/6
            var x1 = x0 - i1 + G2; // Offsets for middle corner in (x,y) unskewed coords
            var y1 = y0 - j1 + G2;
            var x2 = x0 - 1.0 + 2.0 * G2; // Offsets for last corner in (x,y) unskewed coords
            var y2 = y0 - 1.0 + 2.0 * G2;
            // Work out the hashed gradient indices of the three simplex corners
            var ii = i & 255;
            var jj = j & 255;
            // Calculate the contribution from the three corners
            var t0 = 0.5 - x0 * x0 - y0 * y0;
            if (t0 >= 0) {
                var gi0 = permMod12[ii + perm[jj]] * 3;
                t0 *= t0;
                n0 = t0 * t0 * (grad3[gi0] * x0 + grad3[gi0 + 1] * y0); // (x,y) of grad3 used for 2D gradient
            }
            var t1 = 0.5 - x1 * x1 - y1 * y1;
            if (t1 >= 0) {
                var gi1 = permMod12[ii + i1 + perm[jj + j1]] * 3;
                t1 *= t1;
                n1 = t1 * t1 * (grad3[gi1] * x1 + grad3[gi1 + 1] * y1);
            }
            var t2 = 0.5 - x2 * x2 - y2 * y2;
            if (t2 >= 0) {
                var gi2 = permMod12[ii + 1 + perm[jj + 1]] * 3;
                t2 *= t2;
                n2 = t2 * t2 * (grad3[gi2] * x2 + grad3[gi2 + 1] * y2);
            }
            // Add contributions from each corner to get the final noise value.
            // The result is scaled to return values in the interval [-1,1].
            return 70.0 * (n0 + n1 + n2);
        }
    }]);

    return SimplexNoise;
}();

function buildPermutationTable(random) {
    var i = void 0;
    var p = new Uint8Array(256);
    for (i = 0; i < 256; i++) {
        p[i] = i;
    }
    for (i = 0; i < 255; i++) {
        var r = i + 1 + ~~(random() * (255 - i));
        var aux = p[i];
        p[i] = p[r];
        p[r] = aux;
    }
    return p;
}
SimplexNoise._buildPermutationTable = buildPermutationTable;

exports.default = SimplexNoise;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/** speed multiplier for speed table below */
var SPEED_FACTOR = 0.004;

/** Speeds picked at random for the sine-based center target position */
var SPEEDS = [SPEED_FACTOR, 3 * SPEED_FACTOR, 5 * SPEED_FACTOR, 7 * SPEED_FACTOR, 11 * SPEED_FACTOR, 13 * SPEED_FACTOR, 17 * SPEED_FACTOR];

var Config = [{
    color: "#60c9e8",
    lineWidth: 5,
    speeds: [3 * SPEED_FACTOR, 5 * SPEED_FACTOR, 7 * SPEED_FACTOR, 11 * SPEED_FACTOR]
}, {
    color: "#009dcd",
    lineWidth: 3,
    speeds: [5 * SPEED_FACTOR, 7 * SPEED_FACTOR, 11 * SPEED_FACTOR, 13 * SPEED_FACTOR]
}, {
    color: "#009acc",
    lineWidth: 2,
    speeds: [7 * SPEED_FACTOR, 11 * SPEED_FACTOR, 13 * SPEED_FACTOR, 17 * SPEED_FACTOR]
}, {
    color: "#0086b0",
    lineWidth: 1,
    speeds: [3 * SPEED_FACTOR, 7 * SPEED_FACTOR, 5 * SPEED_FACTOR, 11 * SPEED_FACTOR]
}, {
    color: "#006f91",
    lineWidth: 1,
    speeds: [3 * SPEED_FACTOR, 11 * SPEED_FACTOR, 7 * SPEED_FACTOR, 5 * SPEED_FACTOR]
}];
exports.default = Config;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _circle = __webpack_require__(0);

var _circle2 = _interopRequireDefault(_circle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CLEAR_PADDING = 64;

/** how much of the image to retain each frame */
var BLUR_ALPHA = 0.92;

var LogoCircles = function () {
    function LogoCircles(ctx, x, y, size, config) {
        _classCallCheck(this, LogoCircles);

        this.ctx = ctx;
        this.x = x;
        this.y = y;
        this.size = size;

        this.config = config;

        var numCircles = config.length;

        this.circles = new Array(numCircles);

        var halfSize = size / 2;

        for (var i = 0; i < numCircles; i++) {
            this.circles[i] = new _circle2.default(ctx, x + halfSize, y + halfSize, size * 0.6666, config[i]);
        }

        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
    }

    _createClass(LogoCircles, [{
        key: "onMouseUp",
        value: function onMouseUp() {
            var numCircles = this.circles.length;
            for (var i = 0; i < numCircles; i++) {
                this.circles[i].isDragged = false;
            }
        }
    }, {
        key: "onMouseDown",
        value: function onMouseDown(mouseX, mouseY) {

            var numCircles = this.circles.length;
            for (var i = 0; i < numCircles; i++) {
                var circle = this.circles[i];
                if (circle.minDistanceIndex > 0) {
                    var data = circle.data,
                        minDistanceIndex = circle.minDistanceIndex;


                    circle.updateMouse(mouseX, mouseY);
                    circle.isDragged = true;
                    circle.dragOffsetX = data[minDistanceIndex] - mouseX;
                    circle.dragOffsety = data[minDistanceIndex + 1] - mouseY;
                }
            }
        }
    }, {
        key: "onMouseMove",
        value: function onMouseMove(mouseX, mouseY) {
            var numCircles = this.circles.length;
            for (var i = 0; i < numCircles; i++) {
                this.circles[i].updateMouse(mouseX, mouseY);
            }
        }
    }, {
        key: "update",
        value: function update(stats) {
            var numCircles = this.circles.length;
            for (var i = 0; i < numCircles; i++) {
                this.circles[i].update(stats);
            }
        }
    }, {
        key: "clear",
        value: function clear(stats) {
            var ctx = this.ctx;
            var aabb = stats.aabb,
                terrainY = stats.terrainY;


            ctx.save();
            ctx.globalAlpha = BLUR_ALPHA;
            ctx.globalCompositeOperation = "copy";

            var x = aabb.minX - CLEAR_PADDING | 0;
            var y = aabb.minY - CLEAR_PADDING | 0;
            var width = aabb.maxX - aabb.minX + CLEAR_PADDING * 2 | 0;
            var height = aabb.maxY - aabb.minY + CLEAR_PADDING * 2 | 0;

            if (width > 0 && height > 0) {
                ctx.drawImage(ctx.canvas, x, y, width, height, x, y, width, height);
            }

            ctx.restore();

            aabb.reset();
        }
    }, {
        key: "render",
        value: function render(stats) {

            var cpLine = stats.cpLine;
            if (cpLine) {
                var ctx = this.ctx;


                ctx.lineWidth = 1;
                ctx.strokeStyle = "#f08";
                for (var i = 0; i < cpLine.length; i += 8) {
                    ctx.beginPath();
                    ctx.moveTo(cpLine[i], cpLine[i + 1]);
                    ctx.lineTo(cpLine[i + 2], cpLine[i + 3]);
                    ctx.stroke();
                }
                ctx.strokeStyle = "#80f";
                for (var _i = 0; _i < cpLine.length; _i += 8) {
                    ctx.beginPath();
                    ctx.moveTo(cpLine[_i + 4], cpLine[_i + 5]);
                    ctx.lineTo(cpLine[_i + 6], cpLine[_i + 7]);
                    ctx.stroke();
                }
            }

            var numCircles = this.circles.length;
            for (var _i2 = 0; _i2 < numCircles; _i2++) {
                this.circles[_i2].render(stats);
            }
        }
    }]);

    return LogoCircles;
}();

exports.default = LogoCircles;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TERRAIN_PALETTE_SIZE = exports.MIN_Z = exports.MAX_Z = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.dump = dump;

var _noise = __webpack_require__(2);

var _noise2 = _interopRequireDefault(_noise);

var _palette = __webpack_require__(13);

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var simplex = new _noise2.default(Math.random);

var MAX_Z = exports.MAX_Z = 8000;
var MIN_Z = exports.MIN_Z = 250;

var HEIGHT = 300;

var NOISE_SCALE = 0.0004;

var X_SPEED_FACTOR = -30;
var SPEED = 0.625;

function project(n, z) {
    return n / (z * 0.002);
}

function noise(x, y) {
    var v = simplex.noise2D(x, y);
    return v;
}

var TERRAIN_PALETTE_SIZE = exports.TERRAIN_PALETTE_SIZE = 32;
var TERRAIN_PALETTE = (0, _palette2.default)("#000000", "#ffffff", TERRAIN_PALETTE_SIZE);

var LOOKUP_ENTRY_SIZE = 3;

function dump(lookup) {
    var pos = 0;
    while (pos < lookup.length) {
        var color = lookup[pos++];
        var count = lookup[pos++];

        var end = pos + count;
        console.log("COLOR", color, lookup.slice(pos, end));

        pos = end;
    }
}

var Terrain = function () {
    function Terrain(ctx, x, y, width, height, startTime) {
        _classCallCheck(this, Terrain);

        this.ctx = ctx;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;

        this.start = startTime;

        this.xPos = 0;
        this.xSpeed = 0;

        this.fieldSize = 80 + this.width / 24;

        this.lookup = this.prepare();
    }

    _createClass(Terrain, [{
        key: "prepare",
        value: function prepare() {
            var width = this.width,
                fieldSize = this.fieldSize;

            // TERRAIN_PALETTE_SIZE entries with an empty array for each

            var byColor = new Array(TERRAIN_PALETTE_SIZE);

            var radius = MAX_Z - MIN_Z;

            var rSquared = radius * radius;

            var colorFactor = (TERRAIN_PALETTE_SIZE - 1) / radius;

            var halfWidth = width / 2;

            for (var circleZ = radius - fieldSize; circleZ > 0; circleZ -= fieldSize) {
                var circleX = Math.sqrt(rSquared - circleZ * circleZ);

                var numDots = circleX / fieldSize | 0;

                var circleStart = -numDots * fieldSize;

                var xStart = void 0;

                var xProjected = project(circleStart, MIN_Z + circleZ);
                var projectedFieldSize = project(fieldSize, MIN_Z + circleZ);

                // does the circle start outside of the screen?
                if (xProjected < -(halfWidth + projectedFieldSize)) {
                    // -> start at the screen border
                    var count = halfWidth / projectedFieldSize | 0;

                    // we start some field-sizes outside of the screen to be able to "push"
                    // that point into the view via xOff in runtime
                    xStart = -(count + 4) * fieldSize;
                } else {
                    // nope -> start of the circle is fine
                    xStart = circleStart;
                }

                // end is always symmetric to start
                var xEnd = -xStart;

                var z = MIN_Z + circleZ;

                for (var x = xStart; x < xEnd; x += fieldSize) {
                    var distance = Math.sqrt(x * x + z * z);
                    var colorIndex = TERRAIN_PALETTE_SIZE - distance * colorFactor | 0;

                    var array = byColor[colorIndex];

                    if (!array) {
                        byColor[colorIndex] = array = [];
                    }

                    array.push(x, MIN_Z + z, project(1, MIN_Z + z));
                }
            }

            var lookup = [];

            for (var i = 1; i < TERRAIN_PALETTE_SIZE; i++) {
                var _array = byColor[i];
                if (_array) {
                    lookup.push(i);
                    lookup.push(_array.length);
                    lookup.push.apply(lookup, _array);
                }
            }
            return Float32Array.from(lookup);
        }
    }, {
        key: "updateMouse",
        value: function updateMouse(x, y) {
            this.xSpeed = (x / this.width - 0.5) * X_SPEED_FACTOR;
        }
    }, {
        key: "render",
        value: function render(now, stats) {
            var ctx = this.ctx,
                x = this.x,
                y = this.y,
                width = this.width,
                height = this.height,
                start = this.start,
                fieldSize = this.fieldSize,
                lookup = this.lookup;


            ctx.fillStyle = "#000";
            ctx.fillRect(x, stats.terrainY - 1, width, height);

            var halfWidth = width / 2;
            var halfHeight = height / 2;

            var xPos = this.xPos;
            var zPos = -(now - start) * SPEED;

            var xOff = xPos % fieldSize;
            var xRest = xPos - xOff;
            var zOff = zPos % fieldSize;
            var screenY = this.y;

            var minY = Infinity;
            var pos = 0;
            var pointCount = 0;
            var overdraw = 0;
            var overLine = 0;
            while (pos < lookup.length) {
                var color = lookup[pos++];
                var count = lookup[pos++];

                var end = pos + count;

                ctx.fillStyle = TERRAIN_PALETTE[color];

                var overDrawInLine = true;
                for (var i = pos; i < end; i += LOOKUP_ENTRY_SIZE) {
                    var _x = lookup[i];
                    var z = lookup[i + 1];

                    var noiseX = _x + xOff - xPos;
                    var noiseZ = z + zOff - zPos;
                    var currentNoise = noise(noiseX * NOISE_SCALE, noiseZ * NOISE_SCALE);
                    var zScale = Math.cos(noiseZ * NOISE_SCALE) / 2 + 0.5;

                    var _y = halfHeight * 3 + (currentNoise * zScale * HEIGHT - HEIGHT / 2);

                    var yProjected = screenY + height * 0.2 + project(+_y, z + zOff);
                    var xProjected = halfWidth + project(_x + xOff /*+ ((currentNoise * currentNoise) * this.fieldSize)*/, z + zOff);
                    ctx.fillRect(xProjected, yProjected, 2, 2);

                    if (xProjected < 0 || xProjected > width || yProjected > height || yProjected < 0) {
                        overdraw++;
                    } else {
                        overDrawInLine = false;
                    }

                    minY = Math.min(minY, yProjected);
                    pointCount++;
                }

                if (overDrawInLine) {
                    overLine++;
                }

                pos = end;
            }

            this.xPos += this.xSpeed;

            overdraw *= 100 / pointCount;

            stats.terrainY = minY;
            stats.count = Math.max(stats.count, pointCount);
            stats.overdraw = Math.max(stats.overdraw, overdraw);
            stats.overLine = Math.max(stats.overLine, overLine);
        }
    }]);

    return Terrain;
}();

exports.default = Terrain;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var min = Math.min;
var max = Math.max;

/**
 * Axis aligned bounding box
 */

var AABB = function () {
    /**
     * Construct a new ABB
     *
     * @param x0    {number?} minimal x
     * @param y0    {number?} maximal x
     * @param x1    {number?} minimal y
     * @param y1    {number?} maximal y;
     */
    function AABB(x0, y0, x1, y1) {
        _classCallCheck(this, AABB);

        this.reset();

        if (x0 !== undefined) {
            this.extend(x0, y0);
            this.extend(x1, y1);
        }
    }

    /**
     * Resets the min/max values to +/- Infinity
     */


    _createClass(AABB, [{
        key: "reset",
        value: function reset() {
            this.minX = Infinity;
            this.minY = Infinity;
            this.maxX = -Infinity;
            this.maxY = -Infinity;
        }

        /**
         * Extends this AABB with a coordinate or another AABB
         *
         * @param x {number|AABB} x coordinate or AABB value
         * @param y {?number}   y coordinate, will be ignored if first value is AABB
         */

    }, {
        key: "extend",
        value: function extend(x, y) {
            if (x instanceof AABB) {
                this.extend(x.minX, x.minY);
                this.extend(x.maxX, x.maxY);
            } else {
                this.minX = min(this.minX, x);
                this.minY = min(this.minY, y);
                this.maxX = max(this.maxX, x);
                this.maxY = max(this.maxY, y);
            }
        }
    }]);

    return AABB;
}();

exports.default = AABB;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var now = __webpack_require__(15);

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

module.exports = function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = now() - timestamp;

    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  if (true) module.exports = definition()
  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
  else this[name] = definition()

}('domready', function () {

  var fns = [], listener
    , doc = document
    , hack = doc.documentElement.doScroll
    , domContentLoaded = 'DOMContentLoaded'
    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)


  if (!loaded)
  doc.addEventListener(domContentLoaded, listener = function () {
    doc.removeEventListener(domContentLoaded, listener)
    loaded = 1
    while (listener = fns.shift()) listener()
  })

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn)
  }

});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(16)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.components = components;
exports.isColor = isColor;
exports.getLuminance = getLuminance;
exports.contrast = contrast;
exports.mix = mix;
exports.rgb = rgb;
exports.fade = fade;
var LUM_THRESHOLD = exports.LUM_THRESHOLD = 0.03928;
var PERCEPTIVE_FACTOR_RED = exports.PERCEPTIVE_FACTOR_RED = 0.2126;
var PERCEPTIVE_FACTOR_GREEN = exports.PERCEPTIVE_FACTOR_GREEN = 0.7152;
var PERCEPTIVE_FACTOR_BLUE = exports.PERCEPTIVE_FACTOR_BLUE = 0.0722;

var colorRegExp = /^(#)?([0-9a-f]+)$/i;

function checkColor(color) {

    var m = colorRegExp.exec(String(color));
    if (!m) {
        return null;
    }
    var col = m[2];

    if (col.length == 3) {
        return {
            r: parseInt(col[0], 16) / 15,
            g: parseInt(col[1], 16) / 15,
            b: parseInt(col[2], 16) / 15
        };
    } else if (col.length == 6) {
        return {
            r: parseInt(col.substring(0, 2), 16) / 255,
            g: parseInt(col.substring(2, 4), 16) / 255,
            b: parseInt(col.substring(4, 6), 16) / 255
        };
    } else {
        return null;
    }
}

function gun_luminance(v) {

    if (v <= LUM_THRESHOLD) {
        return v / 12.92;
    } else {
        return Math.pow((v + 0.055) / 1.055, 2.4);
    }
}

function hex(n) {
    var s = n.toString(16);

    return s.length == 1 ? "0" + s : s;
}

function components(color) {
    var col = checkColor(color);
    if (!col) {
        throw new Error("Invalid color " + color);
    }
    return col;
}

function isColor(color) {
    var col = checkColor(color);
    return col && !isNaN(col.r) && !isNaN(col.g) && !isNaN(col.b);
}

function getLuminance(color) {
    var c = components(color);
    return PERCEPTIVE_FACTOR_RED * gun_luminance(c.r) + PERCEPTIVE_FACTOR_GREEN * gun_luminance(c.g) + PERCEPTIVE_FACTOR_BLUE * gun_luminance(c.b);
}

function contrast(colorA, colorB) {
    var h = void 0;
    var lum1 = getLuminance(colorA);
    var lum2 = getLuminance(colorB);

    if (lum1 < lum2) {
        h = lum1;
        lum1 = lum2;
        lum2 = h;
    }

    var contrast = (lum1 + 0.05) / (lum2 + 0.05);

    //        console.debug("contrast: %o", contrast);

    return contrast;
}

function mix(col1, col2, ratio) {
    var c1 = components(col1);
    var c2 = components(col2);

    var r = c1.r + (c2.r - c1.r) * ratio | 0;
    var g = c1.g + (c2.g - c1.g) * ratio | 0;
    var b = c1.b + (c2.b - c1.b) * ratio | 0;

    return rgb(r, g, b);
}

function rgb(r, g, b) {
    return "#" + hex(r) + hex(g) + hex(b);
}

function fade(color, opacity) {
    var col = components(color);
    return "rgba(" + col.r + ", " + col.g + ", " + col.b + ", " + opacity + ")";
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = palette;

var _color = __webpack_require__(12);

function palette(from, to, count) {
    var c1 = (0, _color.components)(from);
    var c2 = (0, _color.components)(to);

    console.log(from, c1, to, c2);

    var palette = new Array(count);

    var step = 1 / count;

    var rDelta = c2.r - c1.r;
    var gDelta = c2.g - c1.g;
    var bDelta = c2.b - c1.b;

    for (var i = 0; i < count; i++) {
        var intensity = i * step;

        var r = (c1.r + rDelta * intensity) * 255 | 0;
        var g = (c1.g + gDelta * intensity) * 255 | 0;
        var b = (c1.b + bDelta * intensity) * 255 | 0;

        palette[i] = (0, _color.rgb)(r, g, b);
    }

    return palette;
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var sqrt = Math.sqrt;

var Vector = function () {
    function Vector(x, y) {
        _classCallCheck(this, Vector);

        this.x = x;
        this.y = y;
    }

    /**
     * Returns a copy of this vector.
     *
     * @returns {Vector} copy
     */


    _createClass(Vector, [{
        key: "copy",
        value: function copy() {
            return new Vector(this.x, this.y);
        }

        /**
         * Adds to this vector
         *
         * @param x     {number|Vector} x coordinate or a vector
         * @param y     {number?} y coordinate, ignored if x is a vector
         * @returns {Vector} this vector
         */

    }, {
        key: "add",
        value: function add(x, y) {
            if (x instanceof Vector) {
                this.x += x.x;
                this.y += x.y;
            } else {
                this.x += x;
                this.y += y;
            }

            return this;
        }

        /**
         * Subtracts from this vector
         *
         * @param x     {number|Vector} x coordinate or a vector
         * @param y     {number?} y coordinate, ignored if x is a vector
         * @returns {Vector} this vector
         */

    }, {
        key: "subtract",
        value: function subtract(x, y) {
            if (x instanceof Vector) {
                this.x -= x.x;
                this.y -= x.y;
            } else {
                this.x -= x;
                this.y -= y;
            }

            return this;
        }

        /**
         * Scales the vector by a planar number.
         *
         * @param n     scale
         * @returns {Vector} this vector, scaled
         */

    }, {
        key: "scale",
        value: function scale(n) {
            this.x *= n;
            this.y *= n;

            return this;
        }

        /**
         * Length of this vector
         *
         * @returns {number}    length
         */

    }, {
        key: "length",
        value: function length() {
            var x = this.x,
                y = this.y;

            return sqrt(x * x + y * y);
        }

        /**
         * Scales the vector to normal length or a specified length
         *
         * @param targetLength      {number?} target length of the vector (default is 1, the normal vector length)
         *
         * @returns {Vector}
         */

    }, {
        key: "norm",
        value: function norm() {
            var targetLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            return this.scale(targetLength / this.length());
        }

        /**
         * Rotate vector 90 degrees clockwise.
         *
         * @returns {Vector}
         */

    }, {
        key: "rotateClockwise",
        value: function rotateClockwise() {
            var x = this.x,
                y = this.y;

            //noinspection JSSuspiciousNameCombination

            this.x = y;
            this.y = -x;

            return this;
        }

        /**
         * Rotate vector 90 degrees counter clockwise.
         *
         * @returns {Vector}
         */

    }, {
        key: "rotateCounterClockwise",
        value: function rotateCounterClockwise() {
            var x = this.x,
                y = this.y;


            this.x = -y;
            //noinspection JSSuspiciousNameCombination
            this.y = x;

            return this;
        }
    }]);

    return Vector;
}();

exports.default = Vector;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = Date.now || now

function now() {
    return new Date().getTime()
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 17 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Simplex = undefined;
exports.reduceUpdates = reduceUpdates;
exports.getStats = getStats;

var _raf = __webpack_require__(11);

var _raf2 = _interopRequireDefault(_raf);

var _domready = __webpack_require__(9);

var _domready2 = _interopRequireDefault(_domready);

var _debounce = __webpack_require__(8);

var _debounce2 = _interopRequireDefault(_debounce);

var _performanceNow = __webpack_require__(10);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _noise = __webpack_require__(2);

var _noise2 = _interopRequireDefault(_noise);

var _circle = __webpack_require__(0);

var _circles = __webpack_require__(5);

var _circles2 = _interopRequireDefault(_circles);

var _terrain = __webpack_require__(6);

var _terrain2 = _interopRequireDefault(_terrain);

var _allocate = __webpack_require__(1);

var _allocate2 = _interopRequireDefault(_allocate);

var _aabb = __webpack_require__(7);

var _aabb2 = _interopRequireDefault(_aabb);

var _config = __webpack_require__(4);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderFlag = true;
var skipFrames = false;

var circleCtx = void 0;
var terrainCtx = void 0;
var logoElem = void 0;

var lastTime = void 0;

var circles = void 0,
    terrain = void 0;

var GOLDEN_FACTOR = 0.61803398875;
var UPDATE_INTERVAL = 20;

var NUM_CIRCLES = 5;
var DRAW_CONTROL_POINTS = false;

// coordinates of the graphical center of the logo
var LOGO_CENTER_X = 349;
var LOGO_CENTER_Y = 52;

/**
 * Stats structure that contains aggregated data: a bounding box, a point buffer for control point debug lines.
 *
 * AABB/buffer gets recycled over and over to avoid runtime allocation.
 *
 * @type {{aabb: AABB, terrainY: number, cpLine: (*), cpPos: number}}
 */

function Stats() {
    this.aabb = new _aabb2.default();
    this.terrainY = 0;
    this.cpLine = DRAW_CONTROL_POINTS && "production" !== "production" ? (0, _allocate2.default)(NUM_CIRCLES * _circle.CIRCLE_RESOLUTION * 8) : null;
    this.cpPos = 0;

    this.count = 0;
    this.overdraw = 0;
    this.overLine = 0;
}

var stats = void 0;

function px(n) {
    return (n | 0) + "px";
}

function onMouseMove(ev) {
    ev = ev || window.event;

    var mouseX = ev.pageX;
    var mouseY = ev.pageY;
    if (mouseX === undefined) {
        mouseX = ev.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        mouseY = ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    circles.onMouseMove(mouseX, mouseY);
    terrain.updateMouse(mouseX, mouseY);
}

function onMouseDown(ev) {
    ev = ev || window.event;

    var mouseX = ev.pageX;
    var mouseY = ev.pageY;
    if (mouseX === undefined) {
        mouseX = ev.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        mouseY = ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    circles.onMouseDown(mouseX, mouseY);
}

function initSize(width, height) {
    //console.log("INIT FX SIZE", width, height);

    var circleCanvas = circleCtx.canvas;

    circleCanvas.width = width;
    circleCanvas.height = height;

    if (logoElem) {
        logoElem.style.left = px(width / 2 - LOGO_CENTER_X);
        logoElem.style.top = px(height / 2 - LOGO_CENTER_Y);
    }

    var circlesSize = 500;

    var circlesX = width / 2 - circlesSize / 2;
    var circlesY = height / 2 - circlesSize / 2;

    circles = new _circles2.default(circleCtx, circlesX, circlesY, circlesSize, _config2.default);

    window.onmousemove = onMouseMove;
    window.onmousedown = onMouseDown;
    window.onmouseup = circles.onMouseUp;

    var terrainHeight = window.innerHeight * GOLDEN_FACTOR;
    var terrainY = height - terrainHeight;

    var terrainCanvas = terrainCtx.canvas;

    terrainCanvas.style.top = px(terrainY);
    terrainCanvas.width = width;
    terrainCanvas.height = terrainHeight;

    terrain = new _terrain2.default(terrainCtx, 0, 0, width, terrainHeight, (0, _performanceNow2.default)());

    stats = new Stats();
}

function renderLoop() {

    if (renderFlag) {
        var time = (0, _performanceNow2.default)();

        var delta = time - lastTime;

        stats.cpPos = 0;

        // we consume time in discrete steps
        while (delta > UPDATE_INTERVAL) {
            circles.update(stats);

            delta -= UPDATE_INTERVAL;
        }

        // remember the current time corrected by the time not consumed in this render loop run
        lastTime = time - delta;

        // render current state
        terrain.render(time, stats);
        circles.clear(stats);
        circles.render(stats);
    }

    renderFlag = !skipFrames || !renderFlag;

    (0, _raf2.default)(renderLoop);
}

function initSizeFromWindow() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    initSize(width, height);
}

(0, _domready2.default)(function () {
    var circleElem = document.getElementById("circle-screen");
    var terrainCanvas = document.getElementById("terrain-screen");

    if (circleElem && terrainCanvas) {
        circleCtx = circleElem.getContext("2d");
        terrainCtx = terrainCanvas.getContext("2d");

        logoElem = document.getElementById("dm-logo");

        if (logoElem) {
            logoElem.ondragstart = function (ev) {
                ev.preventDefault();
                return false;
            };
        }

        window.onresize = (0, _debounce2.default)(initSizeFromWindow, 200);

        initSizeFromWindow();

        lastTime = (0, _performanceNow2.default)();
        (0, _raf2.default)(renderLoop);
    }
});

/**
 * If set to true, only render every second frame.
 *
 * @param {?boolean} value     whether to reduce rendering or not, default false. If not given, the current value is returned
 *
 * @returns {boolean}   the current skipFrames value
 */
function reduceUpdates(value) {
    if (value !== undefined) {
        skipFrames = !!value;
    }
    return skipFrames;
}

function getStats() {
    return stats;
}

exports.Simplex = _noise2.default;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dist/develop.me-fx.js